module.exports = __webpack_public_path__ + "img/二维码_梅州.292a6adc.png";